module.exports = __webpack_public_path__ + "img/shengchan4.jpg";